export default __webpack_public_path__ + "static/media/Vice-Chairman.8783f2b8.jpg";